import { inject, Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class PrioritySpinnerService {
  private ngxSpinnerService = inject(NgxSpinnerService);
  private activeSpinner?: string;

  /**
   * Show a spinner, prioritizing named spinners over the global one.
   */
  public show(name?: string): void {
    if (!name) {
      // Global spinner should only show if no named spinners are active
      if (!this.activeSpinner) {
        this.activeSpinner = undefined;
        this.ngxSpinnerService.show();
      }
    } else {
      // If a named spinner is triggered, replace any active spinner
      if (this.activeSpinner !== name) {
        this.hide(this.activeSpinner);
        this.activeSpinner = name;
        this.ngxSpinnerService.show(name);
      }
    }
  }

  /**
   * Hide a specific spinner.
   */
  public hide(name?: string): void {
    if (this.activeSpinner === name) {
      this.ngxSpinnerService.hide(name);
      this.activeSpinner = undefined;
    }
  }

  /**
   * Checks if a named spinner is currently active.
   */
  public isSpinnerActive(name?: string): boolean {
    return this.activeSpinner === name;
  }
}
